export default {
  name: "model-component",
  render() {
    return null;
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    color: String,
    colorAlpha: Number,
    alpha: Number,
    isolate: Boolean,
    show: {
      type: Boolean,
      default: true,
    },
  },
  inject: {
    bimface: {
      default: {
        viewer3D: null,
      },
    },
    model: {
      default: {
        model3D: null,
        modelUpdateVersion: 0,
      },
    },
    material: {
      default: {
        comp: null,
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    model3D() {
      return this.model.model3D;
    },
    viewer3D() {
      return this.model.viewer3D;
    },
  },
  watch: {
    "model.model3D": function (newVal, oldVal) {
      if (newVal) {
        this.init();
      }
    },
    "model.modelUpdateVersion": function (newVal) {
      this.toggleComponent(this.show);
    },
    show: function (newVal, oldVal) {
      this.toggleComponent(newVal);
    },
    alpha: function (newVal, oldVal) {
      this.setAlpha(newVal);
    },
    "material.comp": function (newVal, oldVal) {
      this.loadMaterial(newVal);
    },
  },
  methods: {
    init() {
      this.color && this.setColor(this.color, this.colorAlpha);
      this.alpha && this.setAlpha(this.alpha);
      if (this.show !== undefined) {
        this.toggleComponent(this.show);
      }
      if (this.material && this.material.comp) {
        this.loadMaterial(this.material.comp);
      }
    },
    setColor(color, alpha = 1) {
      this.model3D &&
        this.model3D.overrideComponentsColorById(
          [this.id],
          new Glodon.Web.Graphics.Color(color, alpha)
        );
    },
    setAlpha(alpha) {
      this.model3D &&
        this.model3D.overrideComponentsOpacityById([this.id], alpha);
    },
    toggleComponent(status) {
      if (status) {
        this.model3D.showComponentsById([this.id]);
      } else {
        this.model3D.hideComponentsById([this.id]);
      }
    },
    loadMaterial(materialComp) {
      materialComp.addModelComponent(this.id);
    },
    unloadMaterial(materialComp) {
      materialComp.removeModelComponent(this.id);
    },
  },
  beforeDestroy() {
    if (this.material && this.material.comp) {
      this.unloadMaterial(this.material.comp);
    }
  },
};
